// combatpro/panels/monsters/studio/MonsterStudioHeader.js
//
// Combat PRO - MonsterStudioHeader (Stage 54: Monster Studio Foundation).
//
// The .vi-st-hero block from the master spec (battletracker.html 3315-3332):
// studio title, the editing-monster name mount (#vi-st-hero-name), the official
// / custom counts (#vi-st-stat-official / #vi-st-stat-custom), the cloud-sync
// indicator, and the hero action buttons.
//
// Presentational shell. Stage 56 wires two pieces into the runtime: the hero name
// now shows the engine-derived display name (props.displayName, from
// studioDisplayName), and the New Monster button resets the editor
// (props.onNewMonster). The remaining hero buttons (Load Official / My Library /
// Favourites / Templates) stay inert - their library / persistence / template
// runtimes are deferred to later stages, EXCEPT Templates, which Stage 63 wires to
// the template runtime via props.onOpenTemplates. The stat counts reproduce the master
// spec's static values verbatim; the live counts are wired in a later stage. No
// CombatContext, no persistence, no runtime logic here.

import React from 'react';

function MonsterStudioHeader(props) {
  var displayName = props.displayName || 'Untitled Monster';
  var officialCount = (props.officialCount != null) ? props.officialCount : 0;
  var customCount = (props.customCount != null) ? props.customCount : 0;

  function section(sec) {
    if (props.onSetSection) { props.onSetSection(sec); }
  }

  return (
    <div className="vi-st-hero">
      <div className="vi-st-hero-left">
        <div className="vi-st-hero-title">🧙 Monster Studio</div>
        <div className="vi-st-hero-name" id="vi-st-hero-name">{displayName}</div>
        <div className="vi-st-hero-stats">
          <span><b id="vi-st-stat-official">{officialCount}</b> Official Monsters</span>
          <span><b id="vi-st-stat-custom">{customCount}</b> Custom Monsters</span>
          <span className="vi-st-cloud">☁ Cloud Sync Active</span>
        </div>
      </div>
      <div className="vi-st-hero-actions">
        <button type="button" onClick={props.onNewMonster}>➕ New Monster</button>
        <button type="button" onClick={function() { section('official'); }}>📚 Load Official</button>
        <button type="button" onClick={function() { section('mine'); }}>☁ My Library</button>
        <button type="button" onClick={function() { section('favourites'); }}>⭐ Favourites</button>
        <button type="button" onClick={props.onOpenTemplates}>📋 Templates</button>
      </div>
    </div>
  );
}

export default MonsterStudioHeader;
